export enum SolicitacoesRetornoTypes {
  'LOAD_REQUEST' = '@solicitacoesRetorno/LOAD_REQUEST',
  'LOAD_SUCCESS' = '@solicitacoesRetorno/LOAD_SUCCESS',
  'LOAD_FAILURE' = '@solicitacoesRetorno/LOAD_FAILURE',

  'ITENS_NOTA_SECUNDARIAS_REQUEST' = '@solicitacoesRetorno/ITENS_NOTA_SECUNDARIAS_REQUEST',
  'ITENS_NOTA_SECUNDARIAS_SUCCESS' = '@solicitacoesRetorno/ITENS_NOTA_SECUNDARIAS_SUCCESS',
  'ITENS_NOTA_SECUNDARIAS_FAILURE' = '@solicitacoesRetorno/ITENS_NOTA_SECUNDARIAS_FAILURE',

  'FILTER_SOLICITACOES_RETORNO' = '@solicitacoesRetorno/FILTER_SOLICITACOES_RETORNO',

  'SORTER_SOLICITACOES_RETORNO' = '@solicitacoesRetorno/SORTER_SOLICITACOES_RETORNO',

  'CLEAN_DETALHES_ITENS_NOTA' = '@solicitacoesRetorno/CLEAN_DETALHES_ITENS_NOTA',

  'CLEAN_DETALHES_ITENS_NOTA_SECUNDARIAS' = '@solicitacoesRetorno/CLEAN_DETALHES_ITENS_NOTA_SECUNDARIAS',

  'CLEAN_MOVISAIDA' = '@solicitacoesRetorno/CLEAN_MOVISAIDA',
}

export interface Pagination {
  total: number;
  pageSize: number;
  current: number;
  showSizeChanger: boolean;
  pageSizeOptions: string[];
}

export interface IItensNota {
  nuNota: number;
  volume: string;
  quantidade: number;
  descricaoProduto: string;
  codProduto: number;
  controle: string;
  referencia: string;
  quantidadePendente: number;
  valorTotal: number;
  pesoBruto: number;
}

export interface ISolicitacoesRetorno {
  nuNotaEmitida: any;
  nuNota: number;
  numNota: number;
  dtSolicitacao: Date;
  dhSolicitado: Date;
  pagador: String;
  peso: number;
  valor: number;
  status: String;
  inscricaoEstadualParceiro: String;
  codPagador: number;
  parceiro: string;
  codParceiro: number;
}

export interface IFiltroSaida {
  nfVenda: number;
  nfRemessa: number;
  nfRetorno: number;
  periodoLacamentoInicio: string;
  periodoLacamentoFim: string;
  situacaoAtendimento: string;
  proprietarioMercadoria: string;
  codCentroDistribuicao: number;
  pagadorArmazenagem: string;
  numeroAtendimento: number;
}

export interface IFilter {
  filter: object | undefined;
  codParceiro: number;
}

export interface SolicitacoesRetornoState {
  readonly data: ISolicitacoesRetorno[];
  readonly loading: boolean;
  readonly error: boolean;
  readonly pagination: Pagination;
  readonly notas: IItensNota[];
  readonly filter?: IFilter;
  readonly sorter?: any;
}
